// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  loading: 'Cargando el cambio…',
  load_failed: 'No pude cargar este cambio.',
  load_retry: 'Reintentar',
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Esto ya estaba aprobado, así que no hubo nada más que hacer.',
  action_failed: 'No se completó, así que no se cambió nada. Inténtalo de nuevo en un momento.',
  removed: 'Eliminado',
  retry: 'Reintentar',
  retry_one: 'Reintentar {{name}}',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Aprobado.',
    retried: 'Reintentado.',
    rejected: 'Rechazado.',
  },
  done: {
    summary_one: 'Listo. {{count}} cambio aplicado.',
    summary_other: 'Listo. {{count}} cambios aplicados.',
    skipped_one: '{{count}} omitido, no se cambió nada.',
    skipped_other: '{{count}} omitidos, no se cambió nada.',
  },
  partial: {
    summary_one: '{{applied}} de {{approved}} cambios aplicados. {{count}} no.',
    summary_other: '{{applied}} de {{approved}} cambios aplicados. {{count}} no.',
    detail_one: 'Los {{applied}} están guardados. No se cambió nada en los {{count}} de abajo.',
    detail_other: 'Los {{applied}} están guardados. No se cambió nada en los {{count}} de abajo.',
  },
  stale: {
    summary: '{{applied}} de {{approved}} cambios aplicados.',
    detail_one: '{{count}} fue modificado por otra persona mientras tanto.',
    detail_other: '{{count}} fueron modificados por otra persona mientras tanto.',
    reason:
      '{{name}} lo cambió a {{value}} a las {{time}}, antes de que aprobaras, así que lo dejé como estaba. Aquí está de nuevo a partir del nuevo valor:',
  },
  undone: {
    summary_one: 'Deshecho. El {{count}} cambio vuelve a como estaba.',
    summary_other: 'Deshecho. Los {{count}} cambios vuelven a como estaban.',
    detail: 'Deshacer también queda registrado en el registro de Amigo y en Menú → Historial de ediciones.',
  },
  summary: {
    average: '{{amount}} por plato de media',
    needs_look: 'Requiere revisión',
    nothing_else: 'No cambia nada más',
  },
  labels: {
    waiting: 'Esperando aprobación',
    skip: 'Omitir',
    unskip: 'Deshacer omisión',
    approve_all: 'Aprobar todo',
    approve_one: 'Aprobar {{count}}',
    approve_other: 'Aprobar {{count}}',
    approve_row: 'Aprobar',
    reject: 'Rechazar…',
    reject_confirm: 'Rechazar',
    back: 'Atrás',
    why: {
      amigo: '¿Por qué no? (opcional, Amigo lo lee)',
      assistant: '¿Por qué no? (opcional, el asistente lo lee)',
    },
    hint: 'O responde abajo para cambiar algo.',
    show_all_one: 'Mostrar los {{count}} cambios',
    show_all_other: 'Mostrar los {{count}} cambios',
    show_less: 'Mostrar menos',
    applying_one: 'Aplicando {{count}} cambio…',
    applying_other: 'Aplicando {{count}} cambios…',
    rows: {
      skipped: 'Omitido',
      applied: 'Aplicado',
      failed: 'No aplicado',
      changed: 'Cambiado mientras tanto',
      kept: 'Se deja como está',
    },
    history: {
      amigo: 'Abrir en el registro de Amigo',
      assistant: 'Abrir en el registro del asistente',
    },
    undo: 'Deshacer',
    to: 'a',
    from: 'de',
    rejected: 'Rechazado',
    replaced: 'Reemplazado',
    expired: 'Caducado',
  },
};
